import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import HelpIcon from '@mui/icons-material/Help';

export function IconWithTooltipDescription() {
  return (
    <Tooltip
      title="Nome para identificação da amostra"
      placement="right"
      arrow
    >
      <HelpIcon color="primary" fontSize="inherit" />
    </Tooltip>
  );
}

/*
  const IconWithTooltipCycle = () => (
    <Tooltip title='Ciclo em que foi realizado a amostra' placement='right' arrow>
      <HelpIcon color='primary' fontSize='inherit' />
    </Tooltip>
  );

  const IconWithTooltipPond = () => (
    <Tooltip title="Viveiro ao qual pertence o ciclo" placement="right" arrow >
      <HelpIcon color="primary" fontSize='inherit' />
    </Tooltip>
  );

  */

export function IconWithTooltipSize() {
  return (
    <Tooltip
      title="Número de animais coletados para a amostra"
      placement="right"
      arrow
    >
      <HelpIcon color="primary" fontSize="inherit" />
    </Tooltip>
  );
}

export function IconWithTooltipDate() {
  return (
    <Tooltip title="Data de execução da amostra" placement="right" arrow>
      <HelpIcon color="primary" fontSize="inherit" />
    </Tooltip>
  );
}
